export default {
  empty: '请填写完整',
  fuzhicg: '复制成功',
  fuzhicc: '复制出现异常',
  error:{
	notNull: '不能为空',
	notYes: '不合规'
  },
  login: {
    signUp: '登录',
    title: '您所有数字资产的通用钱包。',
    submit: '登录',
    username: '请填写手机号',
    password: '请填写密码',
    verifycode: '请填写验证码',
    forget_password: '忘记密码?',
    no_account: '没有AuWallet账号？',
    register: '注册',
    verifycode_tip: '请输入验证码',
    verifycode_error: '验证码错误'
  },
  register: {
    title: '手机注册',
    username: '请填写手机号',
    get_code: '获取验证码',
    verifycode: '验证码',
    password: '设置密码',
    repeat: '再次输入',
    invite_code: '邀请码',
    submit: '注册',
    registered: '已有账号',
    go_login: '去登录'
  },
  nologin: {
    cloud_wallet: '云端钱包',
    cloud1: '世界顶尖安全保护',
    cloud2: '独有资产增益，注册存币坐享收益',
    cloud3: '支持超过30+主流币和500+代币',
    button1: '注册',
    button2: '登录',
    button_oauth: '使用 2U.Chat 登录',
    hd_wallet: 'HD钱包',
    hd1: '100%掌管私钥，资产更放心',
    hd2: '一键导入助记词，方便好用',
    hd3: '支持超过30+主流币和500+代币',
    button3: '注册',
    button4: '登录',
    doLogin: "点击登录",
    welcomeTo: "欢迎来到 AuWallet",

  },
  forget: {
    title: '忘记密码？',
    phone_number: '请填写手机号',
    verify_code: '验证码',
    password: '密码',
    repeat: '再次输入密码',
    submit: '确定'
  },
  footer: {
    nav1: '首页',
    // nav2:'行情',
    nav2: '套餐',
    nav3: '财富',
    nav4: '发现',
    nav5: '我的'
  },
  password: {
    title: '设置登录密码',
    password: '输入密码',
    repeat: '再次输入',
    submit: '确认'
  },
  home: {
    total: '总资产',
    invite: '邀请好友',
    redbag: '发红包',
    exchange: '闪兑',
    scan: '扫一扫',
    address_book: '地址簿',
    notice: '历史公告',
    setting: '设置',
    view_mnemonic: '查看助记词',
    backup_mnemonic: '备份助记词',
    create_wallet: '创建钱包',
    import_wallet: '导入钱包',
    welcome: '欢迎',
	cant9sale: 'KYC必须经过2级或2级以上认证，且并未参与过9折购买活动'
  },

  address: {
    new_address: '创建新地址',
    name: '名称',
    address: '地址',
    submit: '立即创建',
    warning_msg: '注意：该地址只能接收ERC20代币，转账的时候请注意不要选错通道。'
  },
  swap: {
    title: '闪兑',
    pay: '您支付',
    balance: '可换余额',
    lock_rate: '请在以下时间内完成支付以锁定此汇率',
    gain: '您获得',
    input: '请输入金额',
    tip: '您获得的币种为空时,说明没有币种可以闪兑。',
    submit: '立即兑换',
    choose_coin: '选择币种',
    notice_2ut: '我已阅读此通知'
  },
  coin: {
    send: '发送',
    swap: '闪兑',
    receive: '接收',
    transactions: '交易记录',
    type1: '内部转账',
    type2: '链上充提',
    type3: '闪兑',
    type4: '理财产品',
    type7: 'HD转出',
    type8: 'HD转入',
    type9: '发送红包',
    type10: '领取红包',
    type11: 'AuWallet转出TimeEx',
    type12: 'TimeEx转入AuWallet',
    type13: '链购服务费',
    type14: '9折服务费',
    type15: '提币',
    type16: 'KYC认证费用',
    flushing: '正在刷新...',
    loading: '正在加载...',
    no_records: '暂无相关记录',
    wallet: ' 钱包',
    tx_time: '交易时间',
    tx_id: '交易ID',
    tx_from: '来自',
    tx_to: '发送到',
    tx_memo: '备注',
    tx_status1: '失败',
    tx_status2: '等待处理',
    tx_status3: '转账成功',
    tx_status4: '转账中',

    receive_address: '请输入收款地址',
    balance: '当前余额',
    fee: '手续费',
    send_all: '发送全部',
    gas_fee: '燃料费',
    slow: '慢',
    fast: '快',
    send: '发送',
    tx_password: '请输入支付密码',
    tx_remark: '备注(选填)',
    address_book1: '云端钱包地址簿',
    address_book2: 'HD钱包地址簿',
    need_pay_pass: '请先设置支付密码',
    need_pin: '请先到个人中心设置pin码',


    set_receive_amount: '设置收款金额',
    receive_amount: '收款金额',
    copy_receive_code: '复制收款码',
    confirm: '确定',
    cancel: '取消',
    rcv_address: '收款地址',
    search: '请输入搜索内容',
    filter: '筛选',
    remove: '移除',
    add: '添加',

    filter1: '所有币种',
    filter2: '已添加币种',
    filter3: '未添加币种',


    notices: 'HD钱包公告',
    notices2: '云端钱包公告',
    only_bitcoin: '这里只有比特币交易',
    only_eth: '此处仅ETH交易',
    only_usdt: '此处仅USDT ERC20交易',
    only_2ut: '此处仅2UT交易',
    only_u2u: '此处仅U2U交易',
    only_2u: '此处仅2U交易',
    only_a2u: '此处仅A2U交易',
    import: '导入',
    info: 'Token 概况'
  },
  market: {
    title: '行情',
    coin: '资产名',
    volume: '交易量',
    price: '价格',
    change: '涨跌幅(24H)',
  },
  discover: {
    title: '发现',
    popular: '最近流行',
    all: '全部'
  },
  my: {
    title: '我的',
    notice: '云端钱包公告',
    login: '点击登录',
    welcome: '欢迎来到AuWallet',
    invite: '邀请',
    news: '每日快讯',
    contact: '联系客服',
    pin_on: '已开启(重置)',
    pin_off: '未开启',
    default_currency: '默认货币',
    red_green: '涨跌颜色',
    option1: '绿涨红跌',
    option2: '红涨绿跌',
    contract: '服务协议',
    privacy: '隐私政策',
    help: '帮助中心',
    faq: '常见问题',
    invite: '我的邀请码',
    onequan: '商务一圈',
    copy: '复制',
    total: '合计',
	downloadapp: '下载手机端应用',
	download: '下载',
	waiting: '等待上线或使用',
	greenxv: 'GreenX操作码',
	greenxvet: '前有效'
  },

  setup: {
    title: '云端钱包设置',
    pay_password: '支付密码',
    on: '已开启',
    off: '未开启',
    google: '谷歌两步验证',
    security_level: '安全等级',
    account_name: '账户名称',
    logout: '退出登录',
    register_time: '注册时间',
    level: '级',
    modify_pay_password: '修改支付密码',
    reset_pay_password: '重置支付密码',
    reset_tip: '为了您的账户安全,请输入原支付密码确认身份',
    forget_pay_password: '忘记支付密码',
    set_pay_password: '设置支付密码',
    enter_password: '请输入密码',
    enter_password2: '请再次输入',
    vcode: '验证码',
    submit: '确认',
    pay_password_wrong: '支付密码错误',
    fontSize: '字体大小'
  },
  news: {
    title: '每日快讯',
    share: '分享',
    good: '利好',
    bad: '利空'
  },

  pin: {
    title: '设置PIN码',
    desc1: '为了保护您的资产安全，请先设置PIN码，PIN码会用于解锁钱包和发币',
    desc2: 'PIN码为本地密码，请妥善保存，如果丢失，无法恢复',
    close: '关闭PIN码',
    title2: '验证PIN码',
    tip2_1: '忘记PIN码？备份钱包后重新安装App并导入助记词后重置'
  },
  google: {
    title: '谷歌两步验证',
    tip: '谷歌两步验证可以为您的账户增加一层保护，当您登陆或者进行交易时，在输入密码的同时，还需要来自两步验证的验证码',
    help: '如何使用谷歌两步验证',
  },
  security: {
    title: '安全等级',
    title2: '身份认证',
    tip: '为了您的资金安全，需要进一步的安全设置和实名信息。',
    l3title: '选择证件类型',
    l3tip: '请选择您的证件的颁发国家',
    c1: '美国',
    c2: '中国大陆',
    c3: '中国港澳台',
    c4: '韩国',
    c5: '日本',
    c6: '新加坡',
    c7: '其他',
	nousdt: 'USDT余额不足3.00，不能进行KYC认证。',


  },
  realname: {
    title: '认证资料',
    tip: 'AuWallet需要您提政府颁发的照片ID来通过安全验证',
    subtitle1: '2U Token (2UT) 認購表格',
    country: '国家',
    country_hint: '您的居住国家',
    firstname: '名字',
    firstname_hint: '名字',
    surname: '姓氏',
    surname_hint: '你的姓氏',
    birthdate: '生日',
    cert_id: '证件号码',
    cert_id_hint: '你的证件号码',
    id_photo1: 'ID正面照片',
    id_photo2: 'ID反面照片',
    address: '居住地',
    address_hint: '您现在的居住地',
    addr_photo: '地址证明',
    asset_photo: '资产证明',
    subtitle2: '投资者资格认证',
    tip1: '本人確認本人至少滿足以下標準中的一項，被發行人認證為合資格投資者（如適用，可勾選多項）',
    tip2: '注（1）：投資組合指證券和現金，不包括房地產。',
    tip3: '注（2）：必須附上近三個月有月結單、計算總結等證明文件',
    invest_exp: '投资经验',
    other_exp: '其他',
    avg_volume: '平均交易额',
    avg_volume_hint: '在過去 12 個月內的平均交易額(美元)',
    avg_num: '平均交易数',
    avg_num_hint: '在過去 12 個月內的平均交易次數',
    exp_year: '投资年限',
    exp_year_hint: '有多少年的投資經驗',
    net_asset: '资产净值',
    net_asset_hint: '資產淨值(美元)',
    risk_tolerance: '风险承受度',
    invest_term: '理想投资期限',
    derivative: '投資衍生品知識',
    signature: '签名',
    reset: '重置',
    subtitle3: '2U Token Subscription Agreement',
    phone_number: '手机号码',
    submit: '提交',
    option1_1: '在個人或與其配偶或子女在聯名賬戶中，擁有不低於 20,000 美元（或等值）的現金和/或證券投資組合的高淨值個人投資者',
    option1_2: '公司或合夥企業的投資組合不少於 20,000 美元或總資產不少於 200 萬美元',
    option1_3: '高淨值個人投資者或公司或合夥企業在 De La O RuralBank Inc. 開設賬戶並在簽署本評估表時擁有不少於 20,000 美元',
    option2_1: '證券',
    option2_2: '期貨',
    option2_3: '配售',
    option2_4: '其他（請註明）',
    option3_1: '高',
    option3_2: '中',
    option3_3: '低',
    option4_1: '多於3年',
    option4_2: '1-3年',
    option4_3: '少於1年',
    option5_1: '是',
    option5_2: '否'
  },
  envelope: {
    title: '配置红包',
    owned: '已有红包',
    amount: '金额',
    quantity: '纸包数',
    quantity_hint: '请填写个数',
    generate: '生成红包',
    title2: '发红包',
    total: '红包总额度',
    wishes: '祝福语',
    submit: '确认支付',
    enter_pass: '请输入支付密码',
    choose_path: '选择发送途径',
    view: '可在已有红包页面查看领取详情',
    choose_coin: '选择币种',
    need_pay_password: '请先设置支付密码',
    share: '将配好的红包分享给好友',
    title3: '已配置红包',
    num: '数量',

  },
  mnemonic: {
    title: '备份钱包助记词',
    tip: '助记词即为私钥，它是掌管您财产的钥匙',
    tip1: '1.由12个字符组成，请抄写并保管在安全的地方。',
    tip2: '2.100%由您保管，一经丢失，无法找回。',
    tip3: '3.请在收币或卸载之前，务必完成助记词备份。',
    backup: '立即备份',
    later: '我先看看，稍后再说',
    tip4: '请环顾四周',
    tip5: '任何人获得助记词，意味着获取了您的资产，请确保周围无人，没有摄像头。',
    understand: '知道了',
    title2: '查看助记词',
    tip6: '您可以导入一下助记词在其他设备上配对，或者用其他设备上的 AuWallet 钱包扫描二维码配对。',
    tip7: '请勿截图！如果有人获取你的助记词将直接获取你的资产！',
    view_code: '查看加密二维码',
    tip8: '加密二维码是为了方便钱包配对新设备，请不要截屏保存，并且确保周围无其他人或者隐藏摄像头。',
    tip9: '该二维码仅限 AU钱包使用。扫描时，需在将要导入的APP内输入当前APP的PIN码，方可成功导入对应的助记词。',

    title3: '请抄写 AuWallet 助记词',
    tip3_1: 'AuWallet 助记词用于恢复钱包，请按照顺序将下方的12个单词抄写到纸上，并保存到安全的地方。',
    tip3_2: '请勿截图！如果有人获取你的助记词将直接获取你的资产！',
    save: '我已安全保存',

    title4: '请确认 AuWallet 助记词',
    tip4_1: '为了确保您已将 AuWallet助记词正确的抄写，请选择对应序号的单词。',
    finish: '完成',
    next: '下一步',
    verror: '验证错误',

    title5: '恢复助记词钱包',
    tip5_1: '请在下方的表格中输入助记词以回复钱包，在每个助记词输入完成后按“空格”键可以跳转到下个单词',
    recover: '开始恢复',
    ask: '覆盖当前钱包？',
    tip5_2: '导入钱包会覆盖当前钱包，如果您还未备份，当前钱包将会永远消失。',
    tip5_3: '我已备份好当前钱包，同意覆盖',
    cancel: '取消',
    import: '继续导入',
    agree: '请选择同意',
    create_success: '创建成功',
    complete: '请填写完整的助记词',
  },
  invite: {
    title: '我的邀请',
    total: '邀请累计',
    invite_num: '好友注册人数',
    bonus1: '一级好友数',
    every: '每人奖励',
    bonus2: '二级好友数',
    bonus3: '三级好友数',
    deposit: '好友存币人数',
    list: '邀请列表',
    subtitle1: '邀请注册',
    subtitle2: '邀请存币',
    no_records: '暂时没有邀请哦'
  },
  lang: {
    set_lang: '设置语言',
  },
  setting: {
    tip: '系统实际以美元进行交易， 系统会自动将用户的委托价格按最新汇率转换为美元， 实际委托价格可能与用户输入价格存在微小差异'
  },
  send: {
    title: '转账类型',
    t1: '提币到Greenx',
    t2: '内部转账',
  },
  sortable: {
    title: '自定义排序',
    drag_to_sort: '拖动排序',
    currency: '货币',
  },
  system: {
    flushing: '正在刷新...',
    loading: '正在加载...',
    btn1: '确定',
    btn2: '取消',
    add: '添加',
    search: '搜索',
    topPullText: '下拉刷新',
    topDropText: '释放刷新',
    topLoadingText: '加载中...',
    copy_succ: '拷贝成功',
    copy_fail: '拷贝失败',
    about: '关于'
  },

  share: {
    title: '分享',
    download: '扫码下载AuWallet',
    sharecode: '邀请码(点击复制)：',
    view_invites: '查看邀请详情',
    copy_link: '拷贝链接',
    attention: '复制以上链接，粘贴到手机浏览器，打开后可下载Au钱包。'
  },

  wealth: {
    tit: '资产',
    title: '我的财富',
    title1: 'PoS挖矿',
    title2: '币计划',
    hot: '热门推荐',
    plan1: '活期',
    plan2: '定期',
    annu_return: '预期年化收益',
    in_amount: '划入金额',
    transfer_all: '全部划转',
    view_rules: '查看规则',
    pay_password: '请输入支付密码',
    asset: '财富资产',
    search: '交易查询',
    rules: '交易规则',
    order_time: '买入时间',
    value_date: '起息日',
    expiry_date: '到期日',
    highlights: '产品亮点',
    remaining_quota: '剩余额度',
    buy: '立即购买',
    ystday_earnings: '昨日收益',
    total_earnings: '累计收益',
    transfer_in: '购入',
    transfer_out: '赎回',
    tran_all: '全部交易',
    tran_in: '购入',
    tran_out: '赎回',
    tran_earning: '增益收入',
    prod_all: '全部产品',
    prod1: 'PoS挖矿',
    prod2: '币计划',
    curr_all: '全部币种',
    out_amount_tip: '请输入转出金额',
    send: '发送',
    success: '赎回成功',
    ok: '交易成功'
  },
  wealth: {
    title: '我的财富',
    title1: '矿业',
    title2: '硬币计划',
    hot: '热门推荐',
    plan1: '按需计划',
    plan2: '固定计划',
    annu_return: '年化回报',
    in_amount: '金额',
    transfer_all: '全部划转',
    view_rules: '查看规则',
    pay_password: '请输入支付密码',
    asset: '财富',
    search: '交易查询',
    rules: '规则',
    order_time: '订购时间',
    value_date: '起息日',
    expiry_date: '到期日',
    highlights: '强调',
    remaining_quota: '剩余配额',
    buy: '立即购买',
    ystday_earnings: "昨天的收益",
    total_earnings: '总收入',
    transfer_in: '购入',
    transfer_out: '赎回',
    transfer_outed: '已赎回',
    tran_all: '全部',
    tran_in: '购入',
    tran_out: '赎回',
    tran_earning: '获得收入',
    prod_all: '全部',
    prod1: 'PoS 挖矿',
    prod2: '硬币计划',
    curr_all: '全部',
    out_amount_tip: '请输入转账金额',
    send: '发送',
    success: '交易成功',
    amount_tip: '请输入金额',
    mbox_title: '提示',
    mbox_msg_unexpired: '提前赎回将无法获取利息',
  },
  ads: {
    title: '好消息',
    content: 'U2U正在抢购中',
    content2: '2UT火热抢购中',
    buy: '购买',
    plan_name: 'U2U New Issue',
    tip: '9折价格购买U2U'

  },
  buyuut: {
    maxtip: '每人限买100',
    current: '当前',
    price: '价格',
    discount: '优惠',
    off: '折',
    amountlabel: '合计购买数量',
    maxerror: '上限100',
    totalprice: '合计价格',
    balance: '可用余额',
    purchase: '立即购买',
    rulestitle: '*活动规则'
  },
  receive: {
    fuzhicg: '复制成功.',
    fuzhicc: '复制失败.',
  },
  alert: {
    cancel: '取消',
    confirm: '确定'
  },
  against: {
    no100: 'USDT必须是100的倍数'
  },
  package: {
    title: '套餐',
    amount: '金额',
    time: '时间',
    coin: 'Token',
    price: '单价',
    scale: '占比',
    quantity: '数量',
    submit: '立即兑换',
    total: '合计',
    points: '积分兑换',
    balance: 'U2U兑换',
    apoints: 'AU可用积分：',
    abalance: '可用余额(U2U)：',
    apoints2: '财富可用收益：',
    import: '导入',
    orders: '兑换记录',
    orders_detail: '兑换详情',
    defi: 'DEFI',
    nopoint: '兑换超过可用积分',
    nobalance: '兑换超过可用余额',
    nologin: '登录已过期，请重新登录。',
    pay_type: '支付方式'
  },
  faqs: {
    faq1: {
      title: "什么是AU钱包？",
      desc: "一个数字资产的通用钱包，包含热钱包和冷钱包。",
      text1: '1. 资产安全',
      text2: '专业的团队让您的资产更安全。',
      text3: '2. 兑换',
      text4: '一个钱包，轻松管理你的2UT、U2U等代币。',
      text5: '我们的服务如下。',
      text6: '1. 联合托管服务',
      text7: '我们与客户合作，通过全面的多重签名授权来共同保护他们的资产。',
      text8: '2. 纯托管服务',
      text9: '资产安全地保存在热/冷存储中，可通过客户确定的定制策略和验证过程进行访问。',
      text10: '3.AuWallet Custody API',
      text11: '我们提供 REST API 支持超过 50+ 主链和 1000+ 代币的钱包服务。',



    },
    faq2: {
      title: "如何下载AuWallet App？",
      desc: "1. 您可以从网站www.auWallet.io下载AuWallet App",
    },
    faq3: {
      title: "如何注册AuWallet App？",
      desc: "1. 无需注册AuWallet。您可以使用 2U 聊天号码和密码登录。",
    },
    faq4: {
      title: "如何使用 2U Chat 登录 AuWallet App？",
      desc: "1. 打开 AuWallet 应用程序",
      text1: '2. 点击 Login with 2U.Chat 按钮',
      text2: '3. 填写2U聊天号码和密码登录AuWallet',
      text3: '4. 登录成功，欢迎使用AuWallet。',
    },
    faq5: {
      title: "如何更改 AuWallet 中的默认语言？",
      desc: "1. 点击底部的 “我的” 菜单",
      text1: '2. 点击设置语言并选择您的语言',
    },
    faq6: {
      title: "如何更改默认货币？",
      desc: "1. 点击右下角的 “我的” 菜单。",
      text1: '2. 从列出的货币列表中选择您的货币。',
    },
    faq7: {
      title: "什么是 PIN 码以及如何设置 PIN 码？",
      desc: "PIN码多层安全保护您用于解锁AuWallet App的资产，当您关闭AuWallet App...",
      text1: '1. PIN码多层安全保护您用于解锁AuWallet App的资产，当您关闭AuWallet App并重新打开它会要求输入PIN码。 PIN码为本地密码，请妥善保管，丢失，无法找回。',
      text2: '2. 您可以在AuWallet App主页右下角的 “我的” 菜单中设置PIN码，点击带有锁定图标的PIN码。',
      text3: '3. 输入 PIN 码',
      text4: '4. 下次您打开 AuWallet 应用程序时，它会询问您在上面设置的 PIN 码。',
    },
    faq8: {
      title: "如何关闭 PIN 码？",
      desc: "1. 点击右下角的 “我的” 菜单，然后点击 PIN",
      text1: '2. 在输入您的 PIN 码之前，它会询问您设置的 PIN 码',
      text2: '3. 点击 “关闭 PIN 码” 链接',
    },
    faq9: {
      title: "什么是支付密码？以及如何设置支付密码？",
      desc: "可以设置支付密码，也可以修改支付密码，但不能关闭支付密码。设置支付密码后，您将成为安全级别 2。",
      text1: '1. 可以设置支付密码，也可以修改支付密码，但不能关闭支付密码。设置支付密码后，您将成为安全级别 2。',
      text2: '2. 打开 AuWallet 应用程序并点击右下角的 “我的” 菜单。',
      text3: '3. 点击右上角的设置图标。',
      text4: '4. 点击支付密码',
      text5: '5. 点击设置支付密码',
      text6: '6. 现在输入支付密码 6 位支付密码',
      text7: '7. 一旦您输入支付密码，它会再次要求您输入支付密码以确保您记住它。',
      text8: '8. 现在您成功设置了支付密码，您就成为了 2 级安全。',
    },
    faq10: {
      title: "如何修改支付密码？",
      desc: "1. 打开AuWallet App，点击右下角的 “我的” 菜单。",
      text1: '2. 点击右上角的设置图标',
      text2: '3. 点击支付密码',
      text3: '4. 点击修改支付密码',
      text4: '5. 输入您之前设置的支付密码。',
      text5: '6. 输入新的支付密码',
      text6: '7. 再次输入新的支付密码',
      text7: '8. 您已成功修改支付密码',
    },
    faq11: {
      title: "如何重置支付密码？",
      desc: "1. 打开AuWallet App，点击右下角的 “我的” 菜单。",
      text1: '2. 点击右上角的设置图标',
      text2: '3. 点击支付密码',
      text3: '4. 点击修改支付密码',
      text4: '5. 点击 “忘记支付密码？” 屏幕中间的链接',
      text5: '6. 您将在手机短信中收到验证码',
      text6: '7. 输入您在短信中收到的代码和新的支付密码，然后点击确认',
      text7: '8. 您成功重置了支付密码。',
    },
    faq12: {
      title: "什么是谷歌验证和如何使用谷歌两种验证？",
      desc: "1. 打开AuWallet App，点击右下角的“我的”菜单。",
      text1: '2. 点击右上角的设置图标',
      text2: '3. 点击谷歌验证',
      text3: '4. 切换 Google 验证按钮',
      text4: '5. 输入您之前设置的支付密码。',
      text5: '6. （仅供参考）此功能正在开发中。',
    },
    faq13: {
      title: "如何创建和使用HD钱包？",
      desc: "AuWallet首页右上角有一个切换按钮，点击它。",
      text1: '1.AuWallet首页右上角有一个切换按钮',
      text2: '点击它。',
      text3: '2. 点击屏幕左中的 “创建钱包” 按钮',
      text4: '3. 您需要设置高清钱包密码并点击下一步按钮',
      text5: '4. 您需要复制生成的AuWallet助记词，然后点击 “我已安全保存” 。',
      text6: '5. 为确保您复制到此处的另一个位置，您需要从先前生成的助记符中选择序列，然后点击下一步按钮。',
      text7: '6. 这里你需要再次确认第二步。查看最开始生成的助记词系统中放置了哪个单词的序列4，选择并继续下一步按钮。',
      text8: '7. 现在您已经成功创建了HD钱包。',
      text9: '8. 现在你需要点击右上角的三个点，然后点击备份助记符',
      text10: '9. 点击立即备份按钮',
      text11: '10. 会弹出消息说小心没有人在点击了解。',
      text12: '11.您可以截图并保存这个AuWallet助记词。',
    },
    faq14: {
      title: "如何导入HD钱包？",
      desc: "1. 点击右上角的三个点，然后点击导入钱包",
      text1: '2. 输入钱包名称和密码并继续导入。',
      text2: '3. 按空格输入助记词，它会移动到下一个框。',
      text3: '4. 您已成功导入您的钱包。 （请确保您正确输入单词，并且通过串行它应该是正确的）',
    },
    faq15: {
      title: "如何退出登录AuWallet App？",
      desc: "1. 打开AuWallet App，点击右下角的 “我的” 菜单。",
      text1: '2. 点击右上角的设置图标。',
      text2: '3. 点击底部的退出登录按钮。',
    },
  },
  service_agreement: {
    title: "AuWallet 服务协议",
    time: "最近更新于：2021 年 12 月 12 日",
    text1: '在使用或访问 AuWallet 提供的任何服务，包括但不仅限于：位于 https:// AuWallet.io 的 AuWallet.io 网 站，通过 APP 应用市场下的 AuWallet APP，和 AuWallet 提供的 API 以及通过 timeEX 提供的任何服务（例如 https:// AuWallet.io/login）（以下统称为“AuWallet”、“服务”或“AuWallet 服务”），您应该仔细阅 读 AuWallet 用户协议（“协议”）并理解所有条款和条件，特别是斜体、粗体、下划线或彩色突出显示的内 容，协议由正文、隐私政策以及任何规则、声明、说明等本网站已经发布或将来可能发布的信息。',
    text2: '为了本协议措辞的方便，本 AuWallet 服务以下也简称为“我们”、“Au 钱包”、“钱包”。',
    text3: '本钱包服务运营 由一家在澳大利亚注册成立的公司，目前提供在线钱包和冷钱包服务。',
    text4: '在你下载并使用我们的软件与服务时，请确保软件及服务的 SSL 证书的真实性。',
    text5: '为免疑义，我们无法控制任何 第三方网站或 APP 服务的内容、隐私政策或行为，也不对其承担任何责任。',
    text6: '对于因使用或依赖任何此类网站或 服务上或通过此类网站或 APP 服务提供的任何此类内容、商品或服务而造成或声称造成的任何损害或损失，我们概不负责或承担任何直接或间接责任。',
    text7: '本《服务协议》（“协议”或“服务协议”）包含管理您访问和使用我们提供的网站和服务（定义如下）的条款和条件，并且是我们与您或您所代表的实体之间的协议。在使用本网站或服务之前，请仔细阅读本《服务协议》。',
    text8: '通过使用本网站，或单击按钮或复选框以接受或同意本《服务协议》的服务条款（如有该选项），或者使用 AuWalletAPP 软件或者填写服务订单，或者，如果更早，使用或以其他方式访问服务，都表示您(1)接受并同意本《服务协议》以及我们不时发布的任何附加条款、规则和参与条件，以及(2)同意如我们的《隐私政策》中所述的收集、使用、披露和其他处理信息的活动。如果您不同意本《服务协议》，则您不得访问或使用服务。',
    text9: '我们在此特别提醒您在使用我们的 AuWallet 移动应用（以下简称“AuWallet”或“本软件”，AuWallet 可在 各移动应用平台上下载，包括但不限于 Google Play Store 和 Apple App Store）之前，请认真阅读本《服务协议》及本《服务协议》中提及的其他文件，尤其是本《服务协议》中“免责及责任限制”条款，确保您充分理解本《服务协议》中各条款，并自主考虑使用 AuWallet 的风险。',
    text10: '一、关于本《服务协议》的确认与接纳', 
    text11: '1.您理解本《服务协议》及有关协议适用于 AuWallet 及 AuWallet 上我们所自主开发和拥有的去中心化  应用（简称“App”）（排除第三方开发的 App）。', 
    text12: '2.您下载 AuWallet 软件并创建身份、恢复身份（定义见下文）或导入钱包，即视为您已经充分阅读并接受本《服务协议》全部条款，本《服务协议》立即生效，对双方具有约束力。如果您不同意本《服务协议》条款，您必须立即停止使用 AuWallet。如果您已经下载了 AuWallet，请立即删除。', 
    text13: '3.在访问或使用 AuWallet 时, 您同意：', 
    text14: '（1）接受本《服务协议》最新版本的约束（无论我们是否事先通知您。）；',
    text15: '（2）在您所适用的司法管辖区域内，您已达到使用 AuWallet 的法定年龄，并可承担因使用 AuWallet  而产生的有约束力法律或金钱义务；且',
    text16: '（3）您不属于被排除人士（如下文所定义）。',
    text17: '4.本《服务协议》可由我们随时更新，经修改的《服务协议》一经在我们的网站上公布，立即自动生效，不再另行通知。在我们公布修改协议条款后，如果您不接受修改后的条款，请立即停止使用 AuWallet。',
    text18: '5.提请您关注，您在对本《服务条款》进行任何此类修改后使用 AuWallet 即表示您接受这些修改后的《服务条款》。',
    text19: '6. 您已达到您所在国家法定年龄具有订立和具有约束力的合同的全部能力； 并拥有签订本协议的全部 权力和授权，并且这样做不会违反您作为一方的任何其他协议。您还声明并保证： 之前没有被 AuWallet 服务 暂停或禁止；',
    text20: '7. 您确认您已符合您所在国家规定的具备签订合同（包括货币、证券、基金、股权等一切金融活动类的合同）的法定年龄，并且您在 AuWallet 服务内注册、通过本服务内购买或销售、在本服务发布信息以及其他表明您接受本网站提供的服务的行为，应遵守对您有管辖权的主权国家或地区的相关法律法 规，并且您确认您有足够的能力接受这些条款和条件，签订交易并使用本 AuWallet 服务进行数字资产交易与管理。',
    text21: '二、定义',
    text22: '1. 被排除国家和人士：被外国资产控制办公室认定为“特别指定国民”； 列入美国商务部的拒绝人员名单； 使用我们的服务会违反任何适用法律的任何领土或国家的居民或国民； 并且不位于朝鲜民主主义人民共和国、苏丹、伊朗、伊拉克、北朝鲜、利比亚、马其顿、利比亚、索马里、叙利亚、克里米亚地区、委内瑞拉、也门或利比亚等国。',
    text23: '2.AuWallet：指由我们基于分布式账本技术开发的多币种数字钱包，包括其他为方便您使用区块链系统而开发的辅助工具。',
    text24: '3.被排除人士：',
    text25: '（1）除了自然人以外的、具备订立本《服务协议》的法律和意识能力的人士；或',
    text26: '（2）因本《服务协议》、法律、监管要求或适用于该用户的司法管辖区的规定而被以任何形式或方式（全部或部分）禁止、限制、无授权或无资格使用服务（如本《服务协议》所定义）的人。',
    text27: `我们不向被排除人士提供服务。如果您是被排除人士，请立即停止使用我们的服务。如果您继续使用我们的服务，您承认并同意您将根据您居住的司法管辖区的适用法律、法规和规定承担所有相应的责任，并且您应使得我们免于承担因您的此类使用行为而引起的任何责任，包括但不限于因此类违反、违约、违法而对我们造成的损失、第三方索赔或行政处罚，以及合理的法律和行政成本、费用和开支，包括合理的律师费在内。 `,
    text28: `4.身份：指基于您的公私钥对生成的数字识别身份`,
    text29: '5.新手指南：指在您使用 AuWallet 之前（及在将来的使用过程中），我们为您提供的 AuWallet 操作指南或基本问题解答，以帮助您了解区块链的基础知识。',
    text30: '6.创建或导入钱包：指在您接受本《服务协议》后，使用 AuWallet 创建或导入钱包的过程。',
    text31: '7.钱包密码：指您在创建 AuWallet 钱包过程中，由您决定的密码，该密码将被用于加密和保护您的私钥。AuWallet 作为去中心化的应用，钱包密码不存储在您的这台移动设备或我们的服务器，一旦您丢失或忘记钱包密码，您需要借助私钥或助记词重置钱包密码。',
    text32: '8.信息提示：AuWallet 软件操作界面涉及的信息提示内容，建议您按照相关步骤进行操作。',
    text33: '9.特定用户：指按照澳洲和其他国家的法律法规及政策规定必须要配合我们履行个人信息披露义务的用户。',
    text34: '10.开发者用户：指按照我们的通知及相关开源协议规定使用 AuWallet 开源代码和开发者模式等针对开发者提供的服务的用户。',
    text35: '11.私钥：由 256 位随机字符构成，是用户拥有并使用数字代币的核心。',
    text36: '12.公钥：由私钥借助密码学原理单向推导生成，并用以生成区块链数字钱包地址，数字钱包地址即为公开收款地址。',
    text37: '13.助记词：符合区块链 BIP39 行业标准，由随机算法生成的 12（或 15/18/21/24）个有序单词组成。是私钥的易记录表现形式，方便您备份保管。',
    text38: '14.Keystore: 是私钥或助记词经过您设置的钱包密码加密保存的文件形式，它只存储在您的这台移动设备中，不会同步至我们的服务器。',
    text39: '15.数字代币：指 AuWallet 目前支持的数字代币种类，包括但不限于 BTC、ETH 等。',
    text40: '16.资料：指 AuWallet 上“浏览”、“市场”等版块的文章等资料，这些资料均为第三方所有，未经授权不得转载。这些资料仅供您参考，并不构成我们对您交易的指导或建议。',
    text41: '17.消息中心：指您可以接收我们发出的信息或通知的收件箱或 2U 号绑定的 2uChat 聊天信息。',
    text42: '18.个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别用户个人身份的各种信息，包括但不限于个人生物识别信息、邮件地址、钱包地址、移动设备信息、操作记录、交易记录等，但不包括用户的钱包密码、私钥、助记词、Keystore。',
    text43: '19.智能合约：指一种旨在以信息化方式传播、验证或执行合同的、基于以太坊的智能化合约，包括但不限于后文提及 Tokenlon 智能合约。',
    text44: '20.WETH：指以太币代币化，因为以太币不符合自己的 ERC20 标准，包装以太币代币化，方便以太币直接与其他代币交易。AuWallet 所支持代币与 WETH 的兑换比率由第三方智能合约决定。',
    text45: '21.ETH：指以太币，是与以太坊区块链相关的加密数字代币，为避免疑问，其不包括“以太坊经典”。',
    text46: '22.AuWallet 开源代码（“AuWallet OSC”）：指我们公开宣布开源的部分 AuWallet 软件代码，允许开发者用户在遵循相关开源协议及我们通知的规定下使用（包括二次开发）该部分开源代码。',
    text47: '23.开源协议：指开发者用户使用 AuWallet 开源代码所应遵循的第三方开源协议。',
    text48: '24.第三方服务：指第三方 App、第三方智能合约、第三方开源协议、第三方硬件钱包、第三方网页、第三方交易所等第三方提供的产品和服务。',
    text49: '25. U2U 币，是由新加坡 U2U 基金会基于以太坊发行的一种加密货币，它可以通过在 2U 聊天平台上体验产品、参与活动等多种方式奖励获得。',
    text50: '26. 2UT 币， 是一款在菲律宾批准上市的 STO 币，它代表了 2U 整个生态的价值，目前已正式在 CryptoSX 上公开发售，2U T 包含“2U Apps Pty Ltd 所持有的 2U 应用平台和多项高科技项目的资产”。 U2U 币可以 1 比 1 兑换 2UT。',
    text51: '27. 2U 积分，由通过分享 2U 聊天平台而奖励获得，当您累计满有 10 个激活的 2U 积分，即可以 1 比 1 兑换 U2U 币（此操作只在你所在国家法律允许的基础上才能进行）。',
    text52: '三、AuWallet 服务（统称“服务”）',
    text53: '1.创建和恢复身份。您可以使用 AuWallet 提供的“创建身份”、“恢复身份”按键进行身份的创建和恢复，并能在一个身份下，同时管理多链钱包。',
    text54: '2.导入钱包。对 AuWallet 支持的数字代币，您可以使用 AuWallet 生成新钱包或导入相关区块链系统的 其它钱包工具生成的兼容钱包。',
    text55: '3.转账、收款。您可以使用 AuWallet 的转账、收款功能进行数字代币的管理，即运用私钥进行电子签名，对相关区块链的账本进行修改。转账是指付款方利用收款方的 ENS 域名或区块链地址进行转账操 作，该“转账”行为涉及在相关区块链系统的分布式账本中对该交易的有效记录（而非在 AuWallet 上实际交付或转让数字代币）。',
    text56: '4.行情查看。您可以使用 AuWallet 查看第三方提供的数字代币汇率价格。AuWallet 通过抓取相应的数字代币汇率信息并展示在 AuWallet 中的“市场”版块。',
    text57: '5.管理数字代币。您可以从 AuWallet 操作界面添加、保管或移除 AuWallet 所支持的数字代币（ETH、BTC 除外）。',
    text58: '6.币币兑换（DEX）。您可以与使用第三方 Tokenlon 智能合约的第三方进行数字代币兑换，由 AuWallet 作为界面工具帮助您和第三方智能合约交互并显示该数字代币兑换的相应结果。',
    text59: '7.浏览 App。您通过 AuWallet 访问并使用该 App（包括我们自己的 App 和第三方 App）提供的服务。',
    text60: '8.搜索 App。您通过 AuWallet 上的搜索框，可以对已在 AuWallet 罗列的 App 进行搜索。',
    text61: '9.集成硬件钱包。您可以使用合适版本的 AuWallet 与特定的硬件钱包进行匹配，并利用硬件钱包确认通过 AuWallet 所进行的交易。',
    text62: '10.免密支付。您可以使用 AuWallet 中的免密支付功能，免密支付将用户钱包密码通过安全加密算法存 储至您的手机设备的 Keychain/Keystore 中，交易时调用您的生物识别（指纹或面容）鉴权，快速完成支付与签名。',
    text63: '11.开发者模式。为方便开发者用户，在开发者模式下开发者用户可以通过搜索框键入 URL 而访问任何其他网站和未在 AuWallet 集成的第三方 App。',
    text64: '12.交易记录。我们将通过区块链系统拷贝您全部或部分的交易记录。但您应以区块链系统的最新交易记录为准。',
    text65: '13.暂停服务。您知悉，基于区块链系统交易“不可撤销”的属性，我们不能为您撤回或撤销交易操作，但在一定情况下，我们可以暂停或者限制某位用户对 AuWallet 软件的操作。',
    text66: '14.其他我们认为有必要提供的服务。',
    text67: '四、5用户使用 AuWallet 时了解并接受：',
    text68: '秉承着区块链的去中心化特点，并为了保护您数字代币安全，我们提供的是去中心化服务，大大区别于银行业金融机构。',    
    text69: '1. 您了解并接受，我们不承担以下责任：',
    text70: '（1）存储您的钱包密码（即您创建/导入钱包时设置的密码）、私钥、助记词或 Keystore；',
    text71: '（2）找回您的钱包密码、私钥、助记词或 Keystore；',
    text72: '（3）冻结钱包；',
    text73: '（4）挂失钱包；',
    text74: '（5）恢复钱包；或',
    text75: '（6）交易回滚。',    
    text76: '2.您应当自行承担保管含有 AuWallet 的移动设备、备份 AuWallet、备份钱包密码、助记词、私钥及 Keystore 的责任。如您遗失移动设备、删除且未备份 AuWallet、删除且未备份钱包、钱包被盗或遗忘钱包密码、私钥、助记词或 Keystore，我们均无法还原钱包或找回钱包密码、私钥、助记词或 Keystore；如用户进行交易时误操作（例如输错转账地址、输错兑换数额），我们无法取消交易，且我们亦不应对此承担任何责任。',
    text77: '3.如您使用 AuWallet 的免密支付功能，请您妥善备份钱包密码。当您的指纹或面容识别多次验证失败之后，您将需要输入自己的钱包密码。如果您遗忘钱包密码的，您需要通过导入助记词/私钥的方式，设置新的钱包密码。我们不存储您的指纹、面容识别等生物信息，且我们亦不应对此承担任何责任。',
    text78: '4.AuWallet 所能够提供的数字代币管理服务并未包括所有已存在的数字代币，请勿通过 AuWallet 操作任何 AuWallet 不支持的数字代币。',
    text79: '5.AuWallet 上集成的 App 包括我们自主拥有的 App 和第三方平台提供的 App。对于第三方平台提供的 App，AuWallet 仅为用户进入 App 提供搜索和区块链浏览器功能，不对第三方 App 的功能或服务质量提供任何担保。您在第三方 App 上接受服务或进行交易前应自行判断和评估该第三方 App 提供的服务或交易是否存在风险。',
    text80: '6.AuWallet 上提供的币币兑换功能的实质是您使用第三方智能合约在区块链系统上进行的数字代币兑换。对于第三方智能合约提供的服务，AuWallet 仅为您提供与第三方智能合约交互的工具，不对第三方智能合约的功能或服务质量提供任何担保。您在该第三方智能合约上接受服务或进行交易前应自行判断和评估该第三方智能合约提供的服务或交易是否存在风险。我们强烈建议您阅读相关智能合约的不断更新的用户协议和/或免责声明。我们保留出于任何原因立即终止或暂停访问这些第三方服务的权利，恕不另行通知或承担责任。',
    text81: '7.AuWallet 上集成的硬件钱包由第三方提供，AuWallet 不对第三方硬件钱包的功能或服务质量提供任何担保，且 AuWallet 不保证实现与任何种类和版本的硬件钱包之间的匹配功能（具体请以我们不时作出的通知为准）。用户在使用第三方硬件钱包之前应自行判断和评估该硬件钱包是否存在风险。您应仔细阅读并同意相关硬件钱包的不断更新的使用许可协议等文件。',
    text82: '8.您在 AuWallet 上使用开发者模式通过输入 URL 访问其他网站或未在 AuWallet 集成的第三方 Apps 的，您知悉并同意您了解 URL 链接的网站和第三方 Apps 可能存在的安全隐患，并独立承担所有的风险和后果。',
    text83: '五. 您的权利义务',
    text84: '（一）创建或导入钱包',
    text85: '1.创建或导入钱包。您有权在您的移动设备上通过 AuWallet 创建和/或导入钱包，有权设定钱包的钱包密码等信息，并有权通过 AuWallet 应用程序，使用自己的钱包在区块链上进行转账和收款等交易。',
    text86: '2.身份验证。按照有关法律法规的要求，特定用户在使用 AuWallet 提供的有关服务时，应当按照 AuWallet 的提示及时完成相关身份验证，要求您提交包括但不限于您的姓名、身份证号码、驾驶证号码、护照号码、手机号码、银行卡号信息等个人信息。否则该特定用户将无法使用有关服务，因特定用户拖延造成的损失由您自行承担。',
    text87: '3.我们可能为不同的终端设备开发不同的软件版本，您应当根据实际需要选择下载合适的版本进行安装。如果您从未经合法授权的第三方获取本软件或与本软件名称相同的安装程序，我们将无法保证该软件能否正常使用，也无法保证其安全性，因此造成的损失由您自行承担。',
    text88: '4.本软件新版本发布后，旧版软件可能无法使用。我们不保证旧版软件的安全性、继续可用性及提供相应的客户服务。请您随时核对并下载最新版本。',
    text89: '（二）使用 AuWallet',
    text90: '1.您应自行承担妥善保管移动设备、钱包密码、私钥、助记词和 Keystore 等信息的责任。我们不负责为您保管以上信息。因您遗失移动设备或硬件钱包、主动或被动泄露、遗忘钱包密码、私钥、助记词、Keystore 或遭受他人攻击、诈骗等所引起的一切风险、责任、损失、费用应由您自行承担。',
    text91: '2.AuWallet 信息提示。您了解并同意遵循我们在 AuWallet 上发布的信息提示，按照信息提示的内容进行操作，否则，由此引起的一切风险、责任、损失、费用等应由您自行承担。',
    text92: '3.您知悉并理解 AuWallet 没有义务对第三方服务履行尽职调查义务，您应当谨慎评估并承担所有与使用 AuWallet 有关的风险。',
    text93: '4.提供信息和文件。如果我们自行认为有必要获取用户的相关信息以遵循任何与使用或操作 AuWallet 相关的适用法律或法规的规定，您应按照我们的要求及时向我们提供该等信息，且您了解并接受，我们可以限制、暂停或终止您使用 AuWallet 直到您提供满足我们要求的信息。您承诺及时向我们告知任何有关其依据本《服务协议》向我们提供的文件和信息中的任何变化，且在没有通知任何变化的书面通知的情形下，我们有权认为由您提供的文件和信息的内容是真实、正确、没有误导信息且没有发生改变的。',
    text94: '5.完成身份验证。当我们合理认为您的交易行为或交易情况出现异常的，或认为您的身份信息存在疑点的，或我们认为应核对您身份证件或其他必要文件的情形时，请您积极配合我们核对您的有效身份 证件或其他必要文件，及时完成相关的身份验证。',
    text95: '6.转账。',
    text96: '（1）您知悉对于 AuWallet 服务中您可使用的日计转账限额和笔数，可能因为您使用该转账服务时所处的国家/地区、监管要求、转账目的、AuWallet 风险控制、身份验证等事由而不同。',
    text97: '（2）您理解基于区块链操作的“不可撤销”属性，当您使用 AuWallet 转账功能时，您应当自行承担因您操作失误而导致的后果（包括但不限于因您输错转账地址、您自身选择转账节点服务器的问题）。',
    text98: '（3）您知悉在使用 AuWallet 服务时，以下情况的出现可能导致转账功能不可用、转账“交易失败”或 “打包超时”：',
    text99: 'a)钱包余额不足；',
    text100: 'b)交易矿工费不足；', 
    text101: 'c)区块链执行智能合约代码失败；', 
    text102: 'd)超出监管部门、AuWallet 或法律法规规定的付款额度；', 
    text103: 'e)网络、设备等技术故障；', 
    text104: 'f)区块链网络拥堵、故障等原因引起交易被抛弃；',
    text105: 'g)您的地址或交易对方地址被识别为特殊地址，如高风险地址。',
    text106: '（4）您知悉 AuWallet 仅向您提供转账工具，在您使用 AuWallet 完成转账后，我们即完成了当次服务的所有义务，我们对其他相关纠纷争议，不承担任何责任。',
    text107: '7.币币兑换。您知悉，币币兑换的每日限额目前由第三方智能合约限定。我们亦可能对您每日可币币兑换的额度进行限制并不时调整。',
    text108: '8.合法合规。您知悉在 AuWallet 进行操作时或利用 AuWallet 上的 App、智能合约进行交易时，您应当遵循有关法律法规、国家政策的要求。',
    text109: '9.公告通知。AuWallet 会以网站公告、消息中心信息、弹窗提示或客户端通知等方式向您发送通知，例如通知您交易进展情况，或者提示您进行相关操作，请您及时予以关注。',
    text110: '10.服务费用与纳税义务：',
    text111: '（1）您使用 AuWallet 的币币兑换服务时，第三方智能合约会向您收取手续费和/或服务费，具体费用以第三方智能合约收取数额为准，AuWallet 信息提示仅供参考；',
    text112: '（2）我们暂时不向您收取任何形式的服务费或手续费，将来需对某些服务进行收费时我们将另行约定或公布规则；',
    text113: '（3）您使用 AuWallet 进行转账时应支付“矿工费”或网络费，金额由您自行决定，并由相关区块链网络收取；',
    text114: '（4）您知悉，在特定情况（包括但不限于您在转账期间为转账支付的“矿工费”或网络费不足，或相关区块链网络不稳定）下，您的转账操作可能失败；在该等情况下，即便您的转账操作未完成，您亦会被相关区块链网络收取矿工费；',
    text115: '（5）您因在 AuWallet 进行交易而发生的所有应纳税负及其它方面的费用均由您负责支付。',
    text116: '（三）开发者用户基于 AuWallet 开源代码的开发',
    text117: '1.开发者用户有权使用我们在官方渠道公布的 AuWallet 开源代码进行应用程序的二次开发，并下载和使用我们针对 AuWallet 开源代码发布的任何补丁或漏洞解决方案。',
    text118: '2.在使用 AuWallet 开源代码时，开发者用户知悉并同意：',
    text119: '（1）如开发者用户在使用 AuWallet 开源代码过程中发现任何漏洞、缺陷或软件改进方案的，应及时联系并告知我们，同时停止任何具有危害性的使用行为（如适用）；',
    text120: '（2）AuWallet 开源代码中可能包含第三方开源协议和源代码，我们不对该等第三方开源协议和源代码的功能、无病毒危害、无漏洞等提供任何形式的担保。开发者用户在使用 AuWallet 开源代码时应自行判断和评估使用后果。开发者用户应仔细阅读并遵循相关开源软件协议（包括但不限于 Apache 协议 http://www.apache.org/licenses/LICENSE-2.0.html）及我们不时作出的通知的要求。',
    text121: '六、风险提示',
    text122: '1.您了解并知悉，由于数字代币领域的法律法规政策尚未健全，该领域的数字代币可能会产生无法兑现、技术不稳定等重大风险。您也了解数字代币的价格波动幅度远高于其他金融资产。我们谨慎提醒您应当根据自身财务状况和风险偏好，以合理的方式选择持有或处置任何一种数字代币。您也了解 AuWallet 提供的行情查看功能仅系抓取部分交易所的数字代币汇率信息的搜索结果，并不表示为最新行情或最佳报价。',
    text123: '2.在使用 AuWallet 服务时，若您或您的相对方未遵从本《服务协议》或相关网站说明、交易、支付页面中之操作提示、规则，我们并不保证交易会顺利完成，且我们不承担损害赔偿责任。若发生前述情形，而款项已先行入账您的或您的交易方的 AuWallet 钱包或第三方钱包，您理解区块链操作具有的“不可逆”属性，以及相关交易具有“不可撤销”的特征，由您及您的相对方自行承担相应的风险后果。',
    text124: '3.您理解并知悉，币币兑换交易均在第三方智能合约上发生、进行并完成。AuWallet 仅作为界面工具帮助您和第三方智能合约交互并显示该已完成交易的相应结果。',
    text125: '4.在您通过 AuWallet 使用第三方服务时，我们强烈建议您仔细阅读该等第三方服务的服务协议、隐私政策和其他相关的文件和信息等，了解交易对象及产品信息，谨慎评估风险后再在该第三方上进行交易。您理解该交易和有约束力的合同关系在您和您的相对方之间建立，与我们无关。我们对因您的交易行为所引起的一切风险、责任、损失、费用不承担任何责任。',
    text126: '5.当您将数字代币转给其他钱包地址时，您在交易过程中应当自行判断对方是否为完全民事行为能力人并自行决定是否与对方进行交易或转账给对方等。',
    text127: '6.在转账过程中，如果出现“交易失败”、“打包超时”等类似的异常信息提示时，您应通过相关区块链系统的官方途径或其他的区块链查询工具进行再次确认，以避免重复转账；否则，由此所引起的一切损失和费用应由您自行承担。',
    text128: '7.您理解当您在 AuWallet 上创建或导入钱包之后，您的 Keystore、私钥、助记词等信息仅存储在当前的这台移动设备中，不存储在 AuWallet 或我们的服务器上。您可以按照 AuWallet 提供的操作指南采取同步钱包等方式更换移动设备。但若您未保存或备份钱包密码、私钥、助记词、Keystore 等信息且在您移动设备丢失的情况下，您的数字代币将因此丢失，我们无法为您找回。若您在导出、保存或备份钱包密码、私钥、助记词、Keystore 等信息的时候泄密，或保存或备份上述信息的设备或服务器被黑客攻击或控制等情况下，您的数字代币将因此丢失，我们无法为您找回。因前述情形产生的任何及所有损失应由您自行承担。',
    text129: '8.我们建议您在创建或导入钱包时对您钱包的钱包密码、私钥、助记词及 Keystore 等信息做好安全备份。我们提请您注意，请不要采用以下电子备份方式：截图、邮件、手机中的记事本应用、短信、微信、QQ 等电子备份方式。我们建议您在纸质记事本上抄写助记词和 Keystore 等信息，同时您亦可将电子数据保管至密码管理器。',    
    text130: '9.我们建议您在选购硬件钱包时应：',
    text131: '（1）确认您购买的硬件钱包是否与 AuWallet 版本相匹配；及',
    text132: '（2）从官方渠道选购全新的硬件钱包。',
    text133: '10.我们善意提醒您谨慎使用 AuWallet 的免密支付功能，建议您在使用前应：',
    text134: '（1）仔细了解您手机设备生物识别的安全等级；',
    text135: '（2）请勿在公共手机中开启免密支付功能；及',
    text136: '（3）如果钱包中的数字资产较大，请勿开启免密支付功能。',
    text137: '11.我们建议您在安全的网络环境中使用 AuWallet，确保您的移动设备没有越狱或 root， 以避免可能存在的安全隐患。',
    text138: '12.请您在使用 AuWallet 过程中，警惕诈骗行为。一旦发现任何可疑行为，我们鼓励您第一时间告知我们。',
    text139: '七、服务的变更、中断、终止',
    text140: '1.您了解并同意我们可以自行决定暂时提供部分服务功能，或于将来暂停部分服务功能或开通新的服务功能。当我们改变服务时，只要您仍然使用 AuWallet，表示您仍然同意本《服务协议》或者本《服务协议》修正后的条款。',
    text141: '2.为了尽可能避免任何对 AuWallet 的误操作或数字代币的任何安全风险，您应避免在不具备区块链基础知识的前提下使用 AuWallet。对不具备区块链基础知识的用户，我们有权拒绝提供部分或全部的服务功能。',
    text142: '3.您理解存在如下情形时，我们将暂停提供服务（或在发生如下情形时彻底终止服务）：',
    text143: '（1）因设备、区块链系统维修、升级、故障和通信中断等技术原因而中断 AuWallet 的运营；',
    text144: '（2）因台风、地震、海啸、洪水、停电、战争或恐怖袭击等不可抗力因素，电脑病毒、木马、黑客攻击、系统不稳定或政府行为等原因，造成我们不能提供服务或我们合理认为继续提供服务会有较大风险的；',
    text145: '（3）适用法律或政策发生重大不利变化的；或',
    text146: '（4）发生我们无法控制或合理预见的其他情形。',
    text147: '4.当用户出现如下情况时，我们可单方面中止或终止您使用 AuWallet 的部分或全部功能:',
    text148: '（1）用户死亡；',
    text149: '（2）盗用他人的钱包信息或移动设备；',
    text150: '（3）在 AuWallet 填写虚假个人信息；',
    text151: '（4）拒绝 AuWallet 的强制更新操作；',
    text152: '（5）违反第三方开源协议或我们通知的规定使用 AuWallet 开源代码；',
    text153: '（6）将 AuWallet 用于违法或犯罪活动；',
    text154: '（7）妨碍其他用户正常使用 AuWallet；',
    text155: '（8）伪称我们的工作人员或管理人员；',
    text156: '（9）攻击、侵入、更改或以任何其他方式威胁我们计算机系统的正常运作；',
    text157: '（10）利用 AuWallet 宣传垃圾广告；',
    text158: '（11）散布谣言，损害我们和 AuWallet 商誉；或',
    text159: '（12）违法行为，其他违反本《服务协议》的行为，及我们合理认为应当暂停功能的情形。',
    text160: '5.如果我们变更、中断、终止服务时，您有权在合理时间内导出您钱包等信息。',
    text161: '八、您的陈述与保证',
    text162: '1.您应遵守您所居住的国家或地区的法律法规，不得将 AuWallet 用于任何非法目的，也不得以任何非法方式使用 AuWallet。',
    text163: '2.您不属于无资格使用 AuWallet 服务的被排除人士。',
    text164: '3.您不得利用 AuWallet 从事任何违法或犯罪的行为，包括但不限于：',
    text165: '（1）危害您所居住的国家或地区的国家安全、泄漏国家秘密、颠覆国家政权、破坏国家统一；',
    text166: '（2）从事任何违法犯罪行为，包括但不限于洗钱、非法集资等；',
    text167: '（3）通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具等，接入我们的服务、收集或处理我们所提供的内容，干预或试图干预任何用户；',
    text168: '（4）提供赌博资讯或以任何方式引诱他人参与赌博；',
    text169: '（5）侵入他人 AuWallet 钱包盗取数字代币；',
    text170: '（6）进行与交易对方宣称的交易内容不符的交易，或不真实的交易；',
    text171: '（7）从事任何侵害或可能侵害 AuWallet 服务系统、数据的行为；',
    text172: '（8）其他我们有正当理由认为不适当的行为。',
    text173: '4.您理解并同意，您将对您违反有关法律（包括但不限于海关及/或税务方面的监管规定）或者本《服务协议》之规定的行为负责，并应对因此类违反、违约、违法而使我们遭受任何的损失、第三方索赔或行政处罚进行赔偿，包括合理的法律和行政成本、费用和支出，以及合理的律师费用。',
    text174: '5.您承诺按时缴纳我们的服务费用（如有），否则我们有权暂停对您提供的服务。',
    text175: '九、隐私政策',
    text176: '1.您提供给我们的任何数据或信息亦受我们隐私政策（“《AuWallet 隐私政策》”的约束，该隐私政策亦是本《服务协议》的一部分。',
    text177: '十、免责及责任限制',
    text178: '1.我们仅对本《服务协议》中所列明的义务承担责任。',
    text179: '2.您理解和同意，在法律所允许的最大范围内，我们只能按照现有的技术水平和条件提供 AuWallet 服 务。因下列任何原因导致 AuWallet 无法正常提供服务，我们不承担责任：',
    text180: '（1）AuWallet 系统停机维护或升级；',
    text181: '（2）因台风、地震、洪水、雷电或恐怖袭击等不可抗力原因；',
    text182: '（3）您的移动设备软硬件和通信线路、供电线路出现故障的；',
    text183: '（4）您操作不当或未通过我们授权或认可的方式使用我们服务的；',
    text184: '（5）因电脑病毒、木马、恶意程序攻击、网络拥堵、系统不稳定、系统或设备故障、通讯故障、电力故障、银行或政府行为等原因；',
    text185: '（6）非因我们的原因而引起的任何其它原因。',
    text186: '3.我们对以下任何情形均不承担责任：',
    text187: '（1）因您遗失移动设备、删除且未备份 AuWallet、删除且未备份钱包、遗忘且未备份钱包密码、私钥、助记词、Keystore 而导致该用户的数字代币丢失；',
    text188: '（2）因您自行泄露钱包密码、私钥、助记词、Keystore，或借用、转让或授权他人使用自己的移动设备或 AuWallet 钱包，或未通过我们官方渠道下载 AuWallet 应用程序或以其他不安全的方式使用 AuWallet 应用程序导致的您的数字代币丢失；',
    text189: '（3）因您误操作（包括但不限于您输错转账地址、您自身选择转账节点服务器的问题）AuWallet 导致的数字代币丢失；',
    text190: '（4）因您不理解区块链技术的知识而进行误操作导致的您的数字代币丢失；',
    text191: '（5）因系统滞后、区块链系统不稳定等原因导致我们拷贝用户在区块链上的交易记录发生偏差；',
    text192: '4.您应承担由下列情形产生或与之相关的风险和后果：',
    text193: '（1）您使用第三方服务操作的交易；',
    text194: '（2）您使用开发者模式；及',
    text195: '（3）您使用币币兑换服务，该等风险和后果应由您、交易相对方和相关智能合约发行方承担。',
    text196: '5.您理解 AuWallet 仅作为您数字代币管理的工具。我们不能控制第三方服务的质量、安全或合法性，信息的真实性或准确性，以及相对方履行其在与您签订的协议项下的各项义务的能力。您自行决定是否使用第三方服务。您理解该交易和有约束力的合同关系在您和您的相对方之间建立，与我们无关。我们提醒您在使用第三方服务前，应谨慎判断第三方服务所提供相关信息的真实性、合法性和有效性。此外，您与任何第三方交易所产生的全部风险亦应由您自行承担。',
    text197: '6.您知悉 AuWallet 可能同时为您及您的交易对手方提供服务或与之有关联关系或其他利益相关的关系，您同意对我们可能存在的该等行为予以明确豁免任何实际或潜在的利益冲突，并不得以此来主张我们在提供服务时存在法律上的瑕疵，也不因此而加重我们的责任或注意义务。',
    text198: '7.我们不提供以下形式的保证：',
    text199: '（1）我们提供的服务将符合您的全部需求；',
    text200: '（2）您经由我们的服务取得的任何技术、产品、服务、资讯或其他材料将符合您的期望；',
    text201: '（3）我们从第三方交易所抓取的数字代币市场交易行情等信息的及时性、准确性、完整性、可靠性；',
    text202: '（4）您在 AuWallet 上的交易对方会及时履行其在与您达成的交易协议中的各项义务。',
    text203: '8.您理解 AuWallet 仅作为您管理数字代币、显示交易信息的工具，我们不提供法律、税务或投资建议等服务。您应当自行向法律、税务、投资方面的专业人士寻求建议，且您在使用我们服务过程中所遭受的投资损失、数据损失等，我们概不负责。',
    text204: '9.您理解根据适用法律法规的要求，我们可能不时更改我们的用户准入标准，限定向特定用户等提供服务的范围和方式等。',
    text205: '十一、其他条款',
    text206: '1.不得转让。在符合本《服务协议》条款的情况下，只有您（而非其他人）有权向我们主张与使用服务相关的索赔。您不得转让、交易，或试图转让、交易您对该索赔的权利。任何该等转让行为均为无效，且我们对受让方不承担任何义务或责任。',
    text207: '2.知识产权。AuWallet 系我们开发并拥有知识产权的应用程序。AuWallet 中显示的任何内容（包括本 《服务协议》、公告、文章、视频、音频、图片、档案、资讯、资料、商标或标识）的知识产权归我们或第三方权利人所有。您仅可为持有和管理数字代币之目的使用 AuWallet 应用程序及其中的内容。未经我们或第三方权利人的事先书面同意（或相关开源协议的允许），任何人不得擅自使用、修改、反向编译、复制、公开传播、改变、散布、发行或公开发表上述应用程序及内容（包括 AuWallet 开源代码）。本《服务协议》不应被视为授予您任何知识产权，包括出于任何目的使用与我们或服务相关的任何信息、图片、用户界面、标识、商标、商业名称、网络域名或版权的权利。',
    text208: '3.非弃权。任何我们未执行本《服务协议》或未向您主张我们在本《服务协议》项下的权利、索赔或诉因的行为均不被视为放弃我们向您主张任何权利、索赔或诉因的权利。',
    text209: '4.完整协议：',
    text210: '（1）本《服务协议》由《AuWallet 服务协议》、《AuWallet 隐私政策》及我们不时公布的各项规则（包括“帮助中心”的内容）组成。',
    text211: '（2）除了本《服务协议》中的《AuWallet 服务协议》、《AuWallet 隐私政策》外，本《服务协议》包含我们之间关于使用 AuWallet 和相关服务的全部协议和谅解，并取代所有先前的（口头的和书面的）协议、谅解或安排。',
    text212: '5.税款：',
    text213: '（1）使用本《服务协议》下的服务不含您在任何法域就您使用本服务所适用、产生、有关的税款 “应纳税款”）。',
    text214: '（2）您应负责确定任何应纳税款，并向合适的税务机关申报、代扣、收集、报告和代缴正确的应纳税款。您应自行承担因未完成或未履行您的任何与应纳税款相关的义务而产生的所有处罚、索赔、罚款、惩罚和其他责任。',
    text215: '（3）我们不负责确定任何应纳税款，亦不负责向合适的税务机关申报、代扣、收集、报告和代缴正确的应纳税款。',
    text216: '6.法律适用。本《服务协议》适用澳洲法律，并应据此解释。',
    text217: '7.管辖权。因本《服务协议》引起的或与之相关的任何争议（包括任何有关其存在、有效性、终止的问题），双方应首先寻求和解。如果该争议在该和解程序开始后的三十(30)天内仍未解决，双方应将该争议提交至澳洲国际仲裁中心（简称“SIAC”），并通过遵循澳洲国际仲裁中心届时有效的仲裁规则（该规则被视为通过引用并入本条款），最终以仲裁的方式在澳洲予以解决。仲裁庭由一名仲裁员组成，由 SIAC 主席任命。仲裁语言为英语。每一方不可撤销地接受澳洲法院之非专属管辖权，以支持和协助根据本段前述内容进行的仲裁程序，包括在该程序的结果作出之前给予临时救济（如必要）。',
    text218: '8.《合同（第三方权利）法》。澳洲的《合同（第三方权利）法》（第 53B 章）（可能不时被修改、修订或补充）应适用于本《服务协议》。非本《服务协议》一方的人士不得拥有本《服务协议》项下的任何权利，也无权执行本《服务协议》。',
    text219: '9.独立性。本《服务协议》的任何部分被任何约束本《服务协议》的立法认为无效、非法或不可执行时，其仅在该范围（且不得进一步扩展）内被视为无效、非法或不可执行。为避免疑问，本《服务协议》的剩余部分将继续有效并保持充分的效力。',
    text220: '10.部分无效。根据任何司法管辖区的法律，本《服务协议》任何条款被认定为非法、无效或不可执行的情形不得影响该条款依据其他司法管辖区的法律被认定为合法、有效或可执行，亦不得影响本《服务协议》其他条款的合法性、有效性或可执行性。',
    text221: '11.本《服务协议》译本。本《服务协议》的任何译本（如有）仅为方便您而提供，无意对本《服务协议》的英文版本进行修改。如果本《服务协议》的英文版本与非英文版本之间存在冲突，应以英文版本为准。',
    text222: '十二、其它',
    text223: '1.您应当全面了解并遵守您所在司法辖区与使用服务所有相关法律、法规及规则。',
    text224: '2.您在使用服务过程中，如遇到任何问题，您可以通过在 AuWallet 提交反馈等方式联系我们。',
    text225: '3.所有的用户可以在 AuWallet 中查看本《服务协议》。我们鼓励您在每次访问 AuWallet 时都查阅本 《服务协议》。',
    text226: '4.本《服务协议》未尽事宜，您需遵守我们不时更新的公告及相关规则。',
    text227: '5.本《服务协议》自 2021 年 10 月 14 日起生效。',
  },
  privacy_policy:{
    title:"AuWallet 隐私政策",
    time:"最近更新于：2021 年 12 月 12 日",
    text1:'尊敬的用户：',
    text2:'AUWALLET PTY. LTD.（以下简称“本公司”或“我们”）尊重并保护用户（以下简称“您”或“用户”）的隐私，当您进行以下行为时，本公司按照本隐私政策（以下简称“本政策”）收集、披露和处理您的个人信息：',
    text3:'(a)进入或使用我们的网站或移动应用（“应用”）及服务；和/或',
    text4:'(b)向我们提供您的个人信息，无论通过何种媒介提供。',
    text5:'本公司建议您在使用应用之前仔细阅读并理解本政策全部内容, 针对免责声明等条款在内的重要信息将 以加粗的形式体现。本政策有关关键词定义与本公司《AuWallet 服务协议》保持一致。如果本政策中使用的定义或术语与《AuWallet 服务协议》中的不一致，以本政策为准。您向我们提供您的个人信息，即代表您同意我们根据本政策的规定收集、使用、披露（包括传输）和处理您的个人信息。如您不接受本政策，请勿 向我们提供任何个人信息。',
    text6:'本政策可由本公司在线随时更新，不另行通知。更新后的政策一经公布在我们的应用上即为生效，并代替原来的政策。修改后的政策将立刻适用于您向我们提供的个人信息。如果您不接受修改后的条款，请立即停止使用应用，您继续使用应用将被视为接受修改后的政策。',
    text7:'一、我们收集您的哪些信息',
    text8:'1.我们将收集您的移动设备信息、操作记录、交易记录、钱包地址等个人信息。',
    text9:'2.为满足您的特定服务需求，我们将收集您的个人信息，包括但不限于您的姓名、银行卡号、手机号码、邮件地址等信息。',
    text10:'3.您知悉：您在应用上的钱包密码、私钥、助记词、Keystore 并不存储或同步至本公司服务器。本公司不提供找回您的钱包密码、私钥、助记词、Keystore 的服务。',
    text11:'4.我们可能要求向您收集更多的个人信息，以使得您可以使用应用上的某些特定功能。如您不同意提供该等个人信息，则视为您放弃使用应用的特定功能。',
    text12:'5.在法律法规允许的范围内，本公司可能会在以下情形中收集并使用您的个人信息，且无需征得您的授权同意：',
    text13:'（1）与国家安全、国防安全有关的；',
    text14:'（2）与公共安全、公共卫生、重大公共利益有关的；',
    text15:'（3）与犯罪侦查、起诉、审判和判决执行等有关的；',
    text16:'（4）所收集的个人信息处于公共领域；',
    text17:'（5）从合法公开披露的信息中收集您的个人信息，如合法的新闻报道，政府信息公开等渠道；',
    text18:'（6）用于维护服务的安全和合规所必需的，例如发现、处理产品和服务的故障；',
    text19:'（7）法律法规允许的其他情形。',
    text20:'6.我们收集信息的方式如下：',
    text21:'（1）当您主动向我们提供信息，无论以何种理由；',
    text22:'（2）当您授权我们向第三方获取您的信息；',
    text23:'（3）您使用我们的应用和服务；',
    text24:'（4）当您通过各种交流渠道与我们的员工联系或互动，例如通过社交平台、通讯平台、当面会议、电话、邮件、传真和书信等；',
    text25:'（5）当您与我们发生交易、与我们联系或要求我们联系您；',
    text26:'（6）当您要求订阅我们的邮件；和/或',
    text27:'（7）我们通过区块链系统，拷贝您全部或部分的交易记录。但您的交易记录应当以区块链系统的记载为准。',
    text28:'7.我们的应用可能包含一些收集个人信息的技术，具体的收集方式将在本政策（见下文第五条）或适用的条款和条件中说明。',
    text29:'8.您向我们提供个人信息系您的主动行为，您可以随时撤回同意。但是，如您选择拒绝向我们提供我们要求的个人信息，您可能无法使用应用，我们可能无法与您联系或向您提供您需要的产品或服务。',
    text30:'9.在某些情况下，您可能向我们提供非您本人的个人信息。如您提供他人信息，您应当保证您已获得该等信息主体的同意，允许我们收集该信息主体的个人信息，并且信息主体同意您向我们披露其个人 信息。您同意，如该等信息主体就我们根据本政策条款收集、使用和披露其个人信息向我们提出索赔，您将向我们进行赔偿并使我们免责。',
    text31:'10.您应确保您向我们提供的个人信息真实、准确和完整。在您的个人信息发生变化时，您应当通知我们。',
    text32:'二、我们如何使用您的信息',
    text33:'1.我们将出于以下一个或多个目的收集、使用或披露您的个人信息：',
    text34:'（2） 向您提供您要求的产品和/或服务；',
    text35:'（2）处理您与我们的关系；',
    text36:'（3）促进您的使用体验；',
    text37:'（4）通过您移动设备的唯一序列号，确认您与您的钱包的对应关系；',
    text38:'（5）向您及时发送重要通知，如软件更新、服务协议及本政策条款的变更；',
    text39:'（6）通过钱包地址和提供的移动设备信息，协助您处理您的提问、反馈、投诉和要求；',
    text40:'（7）告知您我们的产品、服务、项目和活动；',
    text41:'（8）解决争议、调查任何投诉、索赔或争议、或任何实际或可以的非法行为；',
    text42:'（9）进行本公司内部审计、数据分析和研究；',
    text43:'（10）通过跟踪用户对应用的使用情况进行用户行为分析；',
    text44:'（11）遵守法律法规规定及与监管机构的要求；',
    text45:'（12）遵守国际法律法规对于安全以及反洗钱或反恐的要求；',
    text46:'（13）履行我们的义务以及合同条款条件；和/或',
    text47:'（14）任何与前述目的有关的合理目的。',
    text48:'2.如您同意，我们将为其他目的不时使用您的个人信息，例如告知您我们的战略合作伙伴或关联方推出的最新的活动、优惠和推广信息。',
    text49:'3.我们在 AuWallet 的“使用设置”中为您提供“指纹或面容登录”选项，让您便捷地管理您的数字代币。',
    text50:'4.我们在 AuWallet 中为您提供“免密支付”选项，免密支付将您钱包密码通过安全加密算法存储至至您 手机设备的 Keychain/Keystore 中，交易时调用您的生物识别（指纹或面容）鉴权，快速完成支付与签名。',
    text51:'三、您如何控制自己的信息',
    text52:'您在应用中拥有以下对您个人信息自主控制权：',
    text53:'1.您可以通过同步钱包的方式，将您的其他钱包导入应用中，或者将您在应用的钱包导入到其他数字 代币管理钱包中。应用将向您显示导入钱包的信息。',
    text54:'2.您知悉您可以通过“资产”版块内容修改您的数字代币种类、进行转账及收款等活动。',
    text55:'3.您知悉在应用“我”的版块您可以自由选择进行如下操作：',
    text56:'（1）在“使用设置”中，您可以选择不开启“指纹或面容登录”选项，即您可以选择不使用 Touch ID 或 Face ID 验证服务；',
    text57:'（2）在“提交反馈”中，您可以随时向我们提出您对应用问题及改进建议，我们将非常乐意与您沟通并 积极改进我们的服务。',
    text58:'4.您知悉您可以选择不开启“免密支付”选项，即您可以选择不在交易时调用您的生物识别（指纹或面容）鉴权。',
    text59:'5.您知悉，您及我们对于您交易记录是否公开并没有控制权，因为基于区块链交易系统的开源属性，您的交易记录在整个区块链系统中公开透明。',
    text60:'6.我们的应用将包含链接，可链接至非由我们所有、运营、开发或维护的其他网站、应用或智能合约。这些链接系为您方便而提供。本政策仅适用于我们的应用。当您使用第三方服务时，您知悉，我们的《AuWallet 服务协议》、《AuWallet 隐私政策》将不再适用。我们建议您详细阅读并了解其隐私规则 和有关用户服务协议等内容。',
    text61:'7.您有权要求我们更新、更改、删除您的个人信息和/或撤回您给予我们的同意。如果您希望撤回您曾 给予我们的同意，或如您希望更新、更改、删除或访问我们持有的个人信息，或您不接受我们对于本 政策的修改，您可以联系： 邮件地址：service@AuWallet.io',
    text62:'8.为使您管理由我们持有的个人信息，或使您获得有关我们在您提出该等请求前一年内的时间使用（或可能使用）您的个人信息的方式，我们可能向您收取一定的费用。如果我们向您收费，我们将提前告知您收费金额，并在您付费之后满足您的请求。我们将尽力在您提出请求后的三十（30）日内答复您。如果我们无法在三十（30）日内答复，我们将告知您具体的答复时间。',
    text63:'9.在许多情况下，我们需要获得您的个人信息，以使得我们可以向您提供您要求的产品或服务。如您选择拒绝向我们提供我们要求的个人信息或撤回曾给予我们的同意，我们可能无法继续向您提供您要求的产品和服务。',
    text64:'四、我们可能分享或传输您的信息',
    text65:'1.我们将为业务和法律的目的存储您的个人信息。',
    text66:'2.未经过您的同意，我们不会向第三方出售、交易或转让您的个人信息。',
    text67:'3.如果您同意我们向战略合作方或关联方披露您的个人信息，我们可能将您的个人信息披露给该等实体。该等实体将仅为您已同意的目的使用您的个人信息。',
    text68:'4.您同意，我们可能向以下第三方披露或共享您的个人信息：',
    text69:'（1）代表我们并向我们提供服务的服务提供商和数据处理方，例如为我们进行 KYC 检查、会计、数据处理或管理服务、网站托管、维护及运营服务、邮件信息服务、分析服务、支付交易处理、市场营销等；和',
    text70:'（2）我们的咨询师和专业顾问（例如会计师、律师、审计师）。',
    text71:'5.如果为了上述的目的，我们需要将您的个人信息传输至任何其他国家，我们将获得您的同意，并且确保个人信息的接收方具备和我们同等级的个人信息保护措施。如果该等国家或地区尚无可适用于我们与您之间关系的个人信息保护法律，我们将与个人信息接收方签订可合法执行的协议。',
    text72:'6.未经您事先同意，本公司不会将您的个人信息向任何第三方共享或转让，但以下情况除外：',
    text73:'（1）所收集的个人信息是您自行向社会公众公开的；',
    text74:'（2）所收集的个人信息系从合法公开披露的信息中收集，如合法的新闻报道，政府信息公开等渠道；',
    text75:'（3）根据适用的法律法规、法律程序的要求、行政机关或司法机关的要求进行提供或执行本政策以保 护我们或其他方的权利、财产或安全；',
    text76:'（4）在涉及合并、收购时，如涉及到个人信息转让，本公司将要求个人信息接收方继续接受本政策的约束。',
    text77:'五、自动数据收集技术',
    text78:'1.我们在应用中使用自动数据收集技术。例如：',
    text79:'（1）Cookies（或浏览器 cookies）。Cookies 是网站或应用运营方设置的小型文本文件，以识别您的浏览器或设备。我们可能在我们的应用上使用 cookies 技术存储并跟踪信息，例如用户数量及使用频率、用户分布以及用户的线上偏好。cookies 不抓取能够识别您身份的信息，但其收集的信息可协助我们对应用的使用情况进行分析，以提高您的使用体验。您可以在浏览器设置中关闭 cookies。但是，这可能影响应用的功能。',
    text80:'（2）网络分析。网络分析是收集、评估网页和移动应用访问者行为的一种方法。这包括对流量模式进行分析，例如确定网站或移动应用某部分功能的访问频率，或用以了解访问者最感兴趣的信息或服务。我们的应用使用的是第三方工具提供的网络分析服务。',
    text81:'六、我们如何保护您的信息',
    text82:'1.如本公司停止运营，本公司将停止继续收集您个人信息的活动，并采取措施对所持有的您的个人信息在合理期限内进行删除或匿名化处理。',
    text83:'2.为了保护您的个人信息，本公司将采取数据安全技术措施，提升内部合规水平，增加内部员工信息安全培训，并对相关数据设置安全访问权限等方式安全保护您的隐私信息。',
    text84:'3.我们将在 AuWallet“消息中心”中向您发送有关信息安全的消息，并不时在 AuWallet“帮助中心”版块更新钱包使用及信息保护的资料，供您参考。',
    text85:'七、对未成年人的保护',
    text86:'我们对保护未满 18 周岁的未成年人做出如下特别约定：',
    text87:'1.未成年人应当在父母或监护人指导下使用本公司相关服务。',
    text88:'2.我们建议未成年人的父母和监护人应当在阅读本政策、《AuWallet 服务协议》及我们的其他有关规则的前提下，指导未成年人使用应用。',
    text89:'3.本应用将根据适用的法律法规的规定保护未成年人的个人信息的保密性及安全性。',
    text90:'八、免责声明',
    text91:'1.您确认，您使用第三方服务之后，本政策将不再适用于该等第三方对您个人信息的收集、使用、披露和传输行为。本公司无法保证该等第三方会采取合理的安全保护措施。',
    text92:'2.您将自行对使用第三方服务的行为承担责任，并且您同意，如第三方收集、使用、披露和传输您个人信息，导致您受到损失或损害的，您不得要求本公司承担责任。',
    text93:'3. 您确认并接受，在适用的法律允 许的最大限度下，本公司将在现有技术水平条件下，基于“根据现状”、“根据可用”、“不保证无瑕疵”的原则，尽可能采取合理的安全措施保护您的个人信息，以避免信息的泄露、篡改或者毁损。本公司系利用无线方式传输数据，因此，本公司无法确保通过无线网络传输数据的隐私性和安全性。',
    text94:'九、其他',
    text95:'1.您需全面了解并遵守您所在司法辖区与使用本公司服务所有相关法律、法规及规则。',
    text96:'2.法律适用和争议解决：',
    text97:'（1）本政策适用澳洲法律，并应据此解释。',
    text98:'（2）因本政策引起的或与之相关的任何争议（包括任何有关其存在、有效性、终止的问题），双方应首先寻求和解。如果该争议在该和解程序开始后的 30 天内仍未解决，双方应将该争议提交至澳洲国际仲裁中心（简称“ACICA”） 全名: Australia Centre for International Commercial Arbitration，并通过遵循澳洲国际仲裁中心届时有效的仲裁规则（该规则被视为通过引用并入本条款），最终以仲裁的方式在澳洲予以解决。仲裁庭由一名仲裁员组成，由 ACICA 主席任命。仲裁语言为英语。每一方不可撤销地接受澳洲法院之非专属管辖权，以支持和协助根据本段前述内容进行的仲裁程序，包括在该程序的结果作出之前给予临时救济（如必要）。',
    text99:'3.您可以在我们的应用中查看本政策及本公司其他服务规则。我们鼓励您在每次访问应用时都查阅本公司的服务协议及隐私政策。',
    text100:'4.本政策的任何译文版本仅为方便用户而提供，无意对本政策的条款进行修改。如果本政策的英文版本与非英文版本之间存在冲突，应以英文版本为准。',
    text101:'5.本政策自 2021 年 12 月 12 日起适用。',
    text102:'本政策未尽事宜，您需遵守本公司不时更新的公告及相关规则。',
  
  },
  nasdaq:{
	  label :'股票兑换申请',
	  label2 :'申请股票兑换的',
	  apply :'申请',
	  applyed :'已申请',
	  background :'背景说明',
	  text :'1、正式方案须满足（相关股票）所提交NASDAQ股改文件被接收并进入程序倒计时提出。2、在NASDAQ进入正式审核（相关股票）过程中，不排除有驳回或延长时间的可能。',
	  cancel: '取消',
	  submit: '确定',
  },
  ysjjy: "（以实际交易为准）"
}
